import styled, { css } from 'styled-components';
import { borderRadius, mediaQuery, paddings } from '~/styled';

interface ModalContentBodyProps {
  $infoOrErrorOrWarning: boolean;
  $containerWidth?: number;
  $graySurface?: boolean;
  $customStyled?: ReturnType<typeof css>;
}

const sharedStyles = css<ModalContentBodyProps>`
  width: 100%;
  display: block;
  border-radius: ${borderRadius.default};
  background: ${({ theme, $graySurface }) =>
    $graySurface ? theme.colors.grey200 : theme.colors.surface};
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 0;

  ${mediaQuery.up.s`
    width: ${({ $containerWidth }) => ($containerWidth ? `${$containerWidth}px` : 'auto')};
    border-radius: ${borderRadius.default};
    min-width: min(420px , 60%);
    max-width: ${({ $infoOrErrorOrWarning }) =>
      $infoOrErrorOrWarning ? 'max(520px, 30%)' : 'max(600px, 85%)'};
    max-height: min(730px,90%);
  `}

  ${mediaQuery.down.s`
    height: 100%;
  `}

  ${({ $infoOrErrorOrWarning }) =>
    $infoOrErrorOrWarning &&
    mediaQuery.down.s`
      max-width: calc(100% - ${paddings.hugePadding});
      max-height: 75%;
      border-radius: ${borderRadius.default};
      display: flex;
      align-items: center;
      justify-content: center;
      height: auto;
  `}
`;

export const ModalContentBodyForm = styled.form<ModalContentBodyProps>`
  ${sharedStyles}
  ${({ $customStyled }) => $customStyled}
`;

export const ModalContentBodyDiv = styled.div<ModalContentBodyProps>`
  ${sharedStyles}
  ${({ $customStyled }) => $customStyled}
`;
